// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { carMakes } from '../../../types/constants'
import { AddressKinds, ContactsKinds, ManagersContactsKinds, SpecialRequestFormField } from '../../../types/enums'
import { enabledWhen, visibleWhen } from './common'
import { ICompanyManager, ICustomerAddressViewModel, IElementProps, IExternalDataItem } from '../../../types/interfaces'
import { Arr } from '../../../helpers/Arr'

const AddressSearch = (props: IElementProps) => {
  const { t } = useTranslation('common')

  const [searchString, setSearchString] = useState(props.value || '')
  const [filteredManagers, setfilteredManagers] = useState<ICompanyManager[]>([])
  const [filteredAddresses, setfilteredAddresses] = useState<ICustomerAddressViewModel[]>([])
  const [noResults, setNoResults] = useState('')
  const [showOptions, setShowOptions] = useState(false)

  const managersToRender = props.customerManagers
  const addressesToRender = props.customerAddresses
  const companyAddressMode = props.externalDataSourceName === 'companyAddresses'
  const companyManagersMode = props.externalDataSourceName === 'contactFullName'
  const { externalData, formReadOnly } = props
  useEffect(() => {
    if (!formReadOnly && !!externalData && Object.keys(externalData?.data).length > 0) {
      const externalValue = externalData.data[Object.keys(externalData.data)[0]]

      const e = {
        target: {
          value: externalValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      setTimeout(() => {
        props.handleChange(props.name, e)
      }, props.index * 10)
    }
  }, [props.externalData, formReadOnly])

  useEffect(() => {
    if (!!searchString) {
      if (companyAddressMode && !props.value) {
        const found = addressesToRender.filter((el) => fullAddress(el).toLowerCase().indexOf(searchString) > -1)
        setfilteredAddresses(found.sort())
        if (!Arr.any(found) && !props.value) {
          setNoResults('NO_RESULTS_FOUND')
        } else {
          setNoResults('')
        }
      } else {
        setfilteredAddresses([])
        if (showOptions) {
          setfilteredAddresses(addressesToRender.sort())
        }
      }
      if (companyManagersMode && !props.value) {
        const found = managersToRender.filter(
          (c) =>
            c?.displayName?.toLowerCase()?.indexOf(searchString) > -1 ||
            c?.contacts?.find((q) => q?.kind === ManagersContactsKinds.Email)?.value?.indexOf(searchString) > -1
        )
        setfilteredManagers(found.sort())
        if (!Arr.any(found) && !props.value) {
          setNoResults('NO_RESULTS_FOUND')
        } else {
          setNoResults('')
        }
      } else {
        setfilteredManagers([])
        if (showOptions) {
          setfilteredManagers(managersToRender.sort())
        }
      }
    } else {
      setNoResults('')
      if (companyAddressMode) {
        setfilteredAddresses(Arr.any(addressesToRender) ? addressesToRender.sort() : [])
      }
      if (companyManagersMode) {
        setfilteredManagers(Arr.any(managersToRender) ? managersToRender.sort() : [])
      }
    }
  }, [searchString, managersToRender, addressesToRender])

  useEffect(() => {
    if (!!props.value) {
      setSearchString(props.value)
    } else {
      setSearchString('')
    }
  }, [props.value])

  function searchChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setSearchString(e.target.value.toLowerCase())
  }

  function selectbrand(el: any) {
    const e = {
      target: {
        value: companyAddressMode ? fullAddress(el) : el?.displayName,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    if (companyManagersMode) {
      props.prefillManagerContacts(el)
    }
    setfilteredManagers([])
    setfilteredAddresses([])
    setShowOptions(false)
  }

  function removebrand() {
    const e = {
      target: {
        value: '',
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setfilteredManagers([])
    setfilteredAddresses([])
    props.prefillManagerContacts(null)
    props.removeCompanyAddress()
    setShowOptions(false)
    setSearchString('')
  }

  const managersRef = useRef(null)

  function handleDocumentClick(e: Event) {
    if (managersRef.current?.contains(e.target)) {
      return
    } else {
      toggleOptionsList(true)
    }
  }

  function fullAddress(addressInfo: ICustomerAddressViewModel) {
    if (!!addressInfo) {
      const address = `${addressInfo?.street} ${addressInfo?.postalCode} ${addressInfo?.city} ${addressInfo?.country}`
      return address
    } else {
      return ''
    }
  }

  useEffect(() => {
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick, false)
    }
  }, [])

  function toggleOptionsList(close?: boolean) {
    const newState = close ? false : !showOptions
    const eventName = 'mousedown'
    if (!(props.formReadOnly || props.disabledInput)) {
      if (newState) {
        document.addEventListener(eventName, handleDocumentClick, false)
        setfilteredManagers(managersToRender)
        setfilteredAddresses(addressesToRender)
      } else {
        document.removeEventListener(eventName, handleDocumentClick, false)
        setfilteredManagers([])
        setfilteredAddresses([])
      }
      //   setSearchString(props.value || '')
      setShowOptions(newState)
    }
  }

  return (
    <>
      {props.visible && (
        <div style={{ position: 'relative' }} className="formGroup" ref={managersRef}>
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="input-area contract-search">
            <input
              readOnly={props.formReadOnly || props.disabledInput}
              name={`fieldnameveryunique${new Date().getTime()}`}
              type="text"
              placeholder={t('PLEASE_SELECT_COMPANY_AND_SEARCH_MANAGER')}
              autoComplete="none"
              list="autocompleteOff"
              value={searchString}
              className="required-highlight transparent"
              onChange={(e) => searchChanged(e)}
              onClick={(e) => toggleOptionsList()}
            />
            {((Arr.any(filteredManagers) && showOptions) || !!noResults) && companyManagersMode && (
              <div className="cantonsOptionArea">
                {
                  // searchString.length > 2 &&
                  Arr.any(filteredManagers)
                    ? filteredManagers
                        .sort((a, b) => a.displayName.localeCompare(b.displayName))
                        .map((el) => (
                          <a className="cantonsOption" onClick={(e) => selectbrand(el)}>
                            <div>
                              <span>{el?.displayName}; </span>{' '}
                              <span>
                                {el?.contacts?.filter((q) => q?.kind === ManagersContactsKinds.Email)[0]?.value || ''};{' '}
                              </span>
                              <span>
                                {el?.contacts.filter((q) => q?.kind === ManagersContactsKinds.PhoneNumber)[0]?.value ||
                                  ''}
                                ;{' '}
                              </span>
                              {Arr.any(el?.ccNames) && <span>({el?.ccNames?.join(', ')}) ; </span>}
                            </div>
                          </a>
                        ))
                    : noResults && (
                        <a className="cantonsOption">
                          <div>
                            <span>{t(noResults)} </span>
                          </div>
                        </a>
                      )
                }
              </div>
            )}
            {((Arr.any(filteredAddresses) && showOptions) || !!noResults) && companyAddressMode && (
              <div className="cantonsOptionArea">
                {
                  // searchString.length > 2 &&
                  Arr.any(filteredAddresses)
                    ? filteredAddresses.map((el) => (
                        <a className="cantonsOption" onClick={(e) => selectbrand(el)}>
                          <div>
                            <span>{fullAddress(el)}</span>{' '}
                          </div>
                        </a>
                      ))
                    : noResults && (
                        <a className="cantonsOption">
                          <div>
                            <span>{t(noResults)} </span>
                          </div>
                        </a>
                      )
                }
              </div>
            )}
            <i className="icon-search" />
            {searchString.length > 0 && (
              <button title="Clear" className="clr-btn">
                <span className="icon-clear" onClick={(e) => removebrand()}></span>
              </button>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default AddressSearch
